/* ---- ADD TO BAG OPENS THE BAG ----
   The buy button on a product page is a plain Liquid product form. Nothing
   intercepted it, so pressing Add to bag posted to /cart/add and left the
   shopper on the full cart page — a page reload away from the frame they
   were reading, and past the drawer entirely.

   The set module's own button never had this problem: it calls SF.addSet,
   which adds through fetch and opens the drawer. So the two buy paths on
   one page behaved differently, and the quieter of the two was the main one.

   THIS DELEGATES FROM THE DOCUMENT rather than binding to the form, so it
   covers the frame page, the cap page and anything else rendering a product
   form, including markup replaced after load.

   IT FAILS OPEN. If SF has not booted, or the fetch rejects, the form is
   submitted the old way rather than swallowing the click — a shopper must
   never press Add to bag and have nothing happen.

   ONE PAGE IS AN EXCEPTION, AND IT IS NOT HANDLED HERE. On the bundles page
   a shopper is mid-selection, so adding refreshes the bag without opening
   the drawer over the grid. That belongs to SF.addVariant rather than to
   this file, because every add path on that page — this one, the bundle
   button, the add-on row — has to behave the same way. See inBuilder in
   sf-claude.js. Interception still happens here: what must not happen on
   that page is the full-page reload, which is exactly what this prevents.
*/
(function(){
"use strict";
document.addEventListener('submit', function(e){
  var f=e.target;
  if(!f || !f.getAttribute) return;
  var action=f.getAttribute('action')||'';
  if(action.indexOf('/cart/add')<0) return;
  if(!window.SF || typeof window.SF.addVariant!=='function') return; /* post as before */

  var idEl=f.querySelector('[name="id"]');
  var id=idEl && parseInt(idEl.value,10);
  if(!id) return;

  var qEl=f.querySelector('[name="quantity"]');
  var qty=qEl ? (parseInt(qEl.value,10)||1) : 1;

  var btn=f.querySelector('button[type="submit"], [type="submit"]');
  if(btn && btn.disabled) return;

  e.preventDefault();
  if(btn) btn.disabled=true;

  var done=function(){ if(btn) btn.disabled=false };
  try{
    Promise.resolve(window.SF.addVariant(id, qty)).then(done, function(){
      done();
      /* submit() does not re-fire this listener, so this is the plain post. */
      f.submit();
    });
  }catch(err){ done(); f.submit(); }
}, false);
})();